
    var riot = require('riot')
    //src: starling/src/tags/workspace-avatar.html
riot.tag2('workspace-avatar',
  '<div if="{!hasAvatar() && this.isTeamWorkspace()}" class="workspace-logo workspace-logo--default" riot-style="{workspace.color ? \'--workspace-logo-background-color: \' + workspace.color : \'\'}"> {this.workspaceLetter()} </div> <img if="{hasAvatar() && this.isTeamWorkspace()}" class="avatar workspace-logo" riot-src="{this.workspace.logoUrl}"> <img if="{!this.isTeamWorkspace()}" class="avatar workspace-logo workspace-logo--personal" riot-src="{this.workspace.logoUrl}">',
  '',
  'class="workspace-avatar workspace-avatar--{this.opts.size || \'large\'} {\'workspace-logo_container--editable\': isEditable}"', function(opts) {
"use strict";

var _this = this;

this.workspace = this.opts.workspace;

this.isTeamWorkspace = function () {
  if (_this.workspace && _this.workspace.publicIdentifier) return true;
  return false;
};

this.workspaceLetter = function () {
  if (!_this.isTeamWorkspace()) return;
  return Array.from(_this.workspace.name)[0].toUpperCase();
};

this.hasAvatar = function () {
  if (_this.workspace.logoUrl) {
    return true;
  }
  return false;
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('workspace-avatar')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/workspace-avatar.html
// module id = 788
// module chunks = 0